export default __webpack_public_path__ + "static/media/computer.47df44d0.png";